var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInaccurateContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#FFF6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0513 41H39C36.7909 41 35 42.7909 35 45V74.0679C35 76.277 36.7909 78.0679 39 78.0679H44.3846V89L60.0256 78.0679H81.0513C83.2604 78.0679 85.0513 76.277 85.0513 74.0679V45C85.0513 42.7909 83.2604 41 81.0513 41Z",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7005 62.9268H48.9492V51.6668H56.7005M56.7005 62.9268V51.6668M56.7005 62.9268L62.6578 69.7521C63.223 70.3997 64.1124 70.6781 64.9551 70.4713L65.0096 70.4579C66.5481 70.0802 67.2412 68.3197 66.3615 67.0239L63.5801 62.9268H68.8091C70.2562 62.9268 71.3416 61.6267 71.0578 60.2331L69.6818 53.4771C69.4674 52.4245 68.5263 51.6668 67.4332 51.6668H56.7005",
    stroke: "#FF739D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInaccurateContent);
export default __webpack_public_path__ + "static/media/inaccurate-content.2cc6d41b.svg";
export { ForwardRef as ReactComponent };